import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MenuComponent } from '../components/menu/menu.component';
import { KnowledgeCenterComponent } from '../components/knowledge-center/knowledge-center.component';

import { IonicModule } from '@ionic/angular';
import { HeaderComponent } from '../components/header/header.component';



@NgModule({
  declarations: [MenuComponent,KnowledgeCenterComponent,HeaderComponent],
  imports: [
    CommonModule,
    IonicModule
  ],
  exports: [MenuComponent,KnowledgeCenterComponent,HeaderComponent, IonicModule],

})
export class SharedModule { }
